export const TIMEZONES = [
  { val: 'Europe/Kaliningrad', opt: 'Калининград (МСК -1)' },
  { val: 'Europe/Moscow', opt: 'Москва' },
  { val: 'Europe/Volgograd', opt: 'Волгоград (МСК +0)' },
  { val: 'Europe/Samara', opt: 'Самара (МСК +1)' },
  { val: 'Asia/Yekaterinburg', opt: 'Екатеринбург (МСК +2)' },
  { val: 'Asia/Omsk', opt: 'Омск (МСК +3)' },
  { val: 'Asia/Novosibirsk', opt: 'Новосибирск (МСК +4)' },
  { val: 'Asia/Krasnoyarsk', opt: 'Красноярск (МСК +4)' },
  { val: 'Asia/Irkutsk', opt: 'Иркутск (МСК +5)' },
  { val: 'Asia/Yakutsk', opt: 'Якутск (МСК +6)' },
  { val: 'Asia/Vladivostok', opt: 'Владивосток (МСК +7)' },
  { val: 'Asia/Magadan', opt: 'Магадан (МСК +8)' },
  { val: 'Asia/Kamchatka', opt: 'Камчатка (МСК +9)' },
];
